<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>
    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <v-container fluid grid-list-lg> </v-container>
    <v-layout row>
      <v-flex align-center xs12>
        <!-- TABLEAU DE TACHE-->
        <TableauTache :listeTableaux="litesTab"></TableauTache>
        <!-- TABLEAU DE TACHE-->
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex>
        <v-btn class="mb-4" dark color="green" large fab fixed bottom right>
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import TableauTache from "@/components/gestionTache/TableauTache";

export default {
  components: { Loading, TableauTache },
  name: "ListeTableau",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [
        { path: "/tableTache", text: "Tableaux des taches", disabled: false }
      ],

      litesTab: []
    };
  },

  methods: {
    loadChantier() {}
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/gestionTache/ListeTableau.vue